import type { DigitalConsoleType } from '../../consts/ozonetel/sdk';
import { OZONETEL_DEBUG_PREFIX } from './agentAudio';

function readSdkFlag(read: (() => boolean) | undefined): boolean | undefined {
  if (typeof read !== 'function') return undefined;
  try {
    return Boolean(read());
  } catch (error) {
    console.debug(`${OZONETEL_DEBUG_PREFIX} Failed to read SDK state flag`, error);
    return undefined;
  }
}

/**
 * Determines whether the agent session behind an already-initialized SDK is still usable.
 */
export function isOzonetelSessionAlive(dc: DigitalConsoleType) {
  return (
    readSdkFlag(dc.isAgentLoggedIn) !== false && readSdkFlag(dc.isWebsocketConnected) !== false
  );
}

/**
 * Tries to revive a dropped agent websocket in place. Returns false when the SDK cannot recover,
 * which means the caller has to fall back to a full logout/login.
 */
export async function reconnectOzonetelSession(dc: DigitalConsoleType) {
  if (typeof dc.reconnectDC !== 'function') return false;

  try {
    // resolves only once the agent websocket has re-opened, so the check below reads settled state
    await dc.reconnectDC();
  } catch (error) {
    console.debug(`${OZONETEL_DEBUG_PREFIX} Failed to reconnect the agent websocket`, error);
    return false;
  }

  return isOzonetelSessionAlive(dc);
}
